module.exports = __webpack_public_path__ + "static/media/student-money-help.697e9f80.jpg";